(() => {
  if (window.ZqCmpCart) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const openDrawer = (button) => {
    const drawer = document.querySelector('cart-drawer') || document.getElementById('ZqCartDrawer');
    if (drawer && typeof drawer.open === 'function') drawer.open(button);
    else window.location.href = root() + 'cart';
  };
  window.ZqCmpCart = {
    addToCart(variantIdOrIds, options = {}) {
      const button = options.button;
      const openCart = options.openCart !== false;
      const ids = Array.isArray(variantIdOrIds) ? variantIdOrIds : [variantIdOrIds];
      const items = ids.map((id) => ({ id: Number(id), quantity: 1 }));
      if (button) button.setAttribute('aria-busy', 'true');
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (button) button.removeAttribute('aria-busy');
          if (openCart) openDrawer(button);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return data;
        })
        .catch(() => {
          if (button) button.removeAttribute('aria-busy');
        });
    },
    toggleCart(open) {
      if (open) openDrawer();
      else {
        const drawer = document.querySelector('cart-drawer') || document.getElementById('ZqCartDrawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
      }
    },
  };
})();
